import { render, staticRenderFns } from "./AttendeesList.vue?vue&type=template&id=4bdf10fc"
import script from "./AttendeesList.vue?vue&type=script&setup=true&lang=ts"
export * from "./AttendeesList.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports